import React, { useContext, useState, useRef, useEffect } from 'react';
import {
  Box,
  Paper,
  Typography,
  TextField,
  Button,
  Alert,
  Stack,
  InputAdornment,
  Snackbar,
  Backdrop,
  CircularProgress
} from '@mui/material';
import EmailIcon from '@mui/icons-material/Email';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import Header from '../Header';
import { motion } from 'framer-motion';
import { endpoint } from '../../resource/Constant';
import { parseEmail } from '../../resource/Constant';
import { usePrescriptionDetectorAuth } from './PrescriptionDetectorAuthProvider';

const PresDectLogin = () => {
  const [email, setEmail] = useState('');
  const [otp, setOtp] = useState(['', '', '', '']);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [otpSent, setOtpSent] = useState(false);
  const [resendTimer, setResendTimer] = useState(30);
  const otpInputs = useRef([]);
  const navigate = useNavigate();
  const { presDectLogin } = usePrescriptionDetectorAuth();
  const [loader, setLoader] = useState(false);

  const stepVariants = {
    initial: { opacity: 0, x: 50 }, // Start off-screen
    animate: { opacity: 1, x: 0 }, // Slide in
    exit: { opacity: 0, x: -50 }, // Slide out
  };

  useEffect(() => {
    let timer;
    if (otpSent && resendTimer > 0) {
      timer = setInterval(() => {
        setResendTimer((prev) => prev - 1);
      }, 1000);
    }
    return () => clearInterval(timer);
  }, [otpSent, resendTimer]);

  const handleSendOtp = (e) => {
    e.preventDefault();
    setMessage('');
    setError('');
    setLoader(true);
    const params = { email: email };

    if (email === parseEmail){
      axios.post(endpoint + '/api/prescription/parse' , {} , {params : {...params}})
      .then((response) => {
        localStorage.setItem('presdecttoken', response?.data?.jwt);
        presDectLogin();
        navigate('/prescription/detector');
        setLoader(false)
      })
      .catch((error) => {
        setError(error?.response?.data?.detail || "Failed to send an OTP")
        setLoader(false)
      })
    }
    else {
      axios
      .post(endpoint + `/api/prescription/sendotp`, {}, { params: { ...params } })
      .then((res) => {
        setMessage(res?.data?.message)
        setOtpSent(true)
        setResendTimer(30)
        setLoader(false)
      })
      .catch((error) => {
        setError(error?.response?.data?.message || "Failed to send an OTP")
        setLoader(false)
      })
    }
    
  };

  const handleSignIn = (e) => {
    e.preventDefault();
    setMessage('');
    setError('');
    setLoader(true);
    const otpValue = otp.join('');
      axios
      .post(endpoint + '/api/prescription/verifyotp', {}, { params: { email: email, otp: otpValue } })
      .then((response) => {
        setMessage(response?.data?.message)
        localStorage.setItem('presdecttoken', response?.data?.data?.token);
        presDectLogin();
        navigate('/prescription/detector');
        setLoader(false)
      })
      .catch((error) => {
        setError(error?.response?.data?.message)
        setLoader(false)
      })
  };

  const handleOtpChange = (index, value) => {
    if (isNaN(value)) return;

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    if (value && index < 3) {
      otpInputs.current[index + 1].focus();
    }
  };

  const handleOtpKeyDown = (index, e) => {
    if (e.key === 'Backspace' && !otp[index] && index > 0) {
      otpInputs.current[index - 1].focus();
    }
  };

  const handleResendOtp = async () => {
    setMessage('');
    setError('');
    setLoader(true);
    try {
      const params = { email: email };
      const response = await axios.post(endpoint + '/api/jobdescription/resendotp', {}, { params: { ...params } });

      if (response.status === 200) {
        setMessage(`New OTP sent to ${email}`);
        setResendTimer(30);
        setOtp(['', '', '', '']);
      }
    } catch (err) {
      setError(err.response.data.detail || 'Failed to resend OTP. Please try again.');
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    if (localStorage.getItem('presdecttoken')) {
      presDectLogin();
      navigate('/prescription/detector');
    }
  }, []);

  return (
    <>
      <Header />
      <motion.div
      key="step1"
      variants={stepVariants}
      initial="initial"
      animate="animate"
      exit="exit"
      transition={{ duration: 0.4 }}
      >
      <Box
      // key="step1"
      // variants={stepVariants}
      // initial="initial"
      // animate="animate"
      // exit="exit"
      // transition={{ duration: 0.4 }}
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '100vh',
          backgroundColor: '#f4f6f8',
          flexDirection: 'column'
        }}
      >
        {/* <Box
          sx={{
            backgroundColor: 'rgb(240, 248, 255)', // Light blue background
            padding: '20px',
            borderRadius: '10px',
            boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)', // Subtle shadow
            maxWidth: '800px',
            margin: '20px auto', // Centering the box
            textAlign: 'center'
          }}
        >
          <Typography variant="h6" sx={{ fontWeight: 'bold', color: 'rgb(28, 113, 198)' }}>
            Job Description AI
          </Typography>
          <Typography variant="body1" sx={{ marginTop: '10px', color: 'rgb(50, 50, 50)' }}>
            Our chatbot streamlines the process of creating job descriptions by guiding users through interactive questions. It gathers key
            details such as <strong>role, required skills, additional information, company name, and location</strong> to generate a
            structured and well-defined job description effortlessly.
          </Typography>
        </Box> */}
        <Paper
          sx={{
            width: '100%',
            maxWidth: '500px',
            p: 3,
            borderRadius: '12px',
            background: 'rgba(255, 255, 255, 0.8)',
            backdropFilter: 'blur(10px)',
            boxShadow: '0 8px 16px rgba(0, 0, 0, 0.1)',
            animation: 'fadeIn 0.6s ease-in-out'
          }}
        >
          {<Typography variant="h6" sx={{textAlign : 'center' , fontWeight: 'bold', color: 'rgb(28, 113, 198)' }}>
            Email Verification
          </Typography>}
          {!otpSent && <Typography variant="body1" sx={{textAlign : 'center' , marginTop: '10px', color: 'rgb(50, 50, 50)' , mb: 2}}>
          </Typography>}
          {/* Title */}
          {/* <Typography
            variant="h4"
            sx={{
              textAlign: 'center',
              fontSize: '30px',
              mb: 2,
              fontWeight: 'bold',
              color: '#1976d2'
            }}
          >
            Verification
          </Typography> */}
          {!otpSent && <Typography variant="body1" sx={{ mb: 3, textAlign: 'center', color: 'gray' }}>
            Enter your email to receive an OTP for verification.
          </Typography>}

          {otpSent && <Typography variant="body1" sx={{ mb: 3, textAlign: 'center', color: 'gray' }}>
          Enter the OTP sent to your email to proceed. (Check your spam folder if you don’t see it.)
          </Typography>}

          {/* Card Container with Glassmorphism */}
          <Paper
            sx={{
              width: '100%',
              maxWidth: '500px',
              p: 3,
              borderRadius: '12px',
              background: 'rgba(241, 239, 239, 0.48)',
              backdropFilter: 'blur(10px)',
              boxShadow: '0 8px 16px rgba(0, 0, 0, 0.1)',
              animation: 'fadeIn 0.6s ease-in-out'
            }}
          >
            <form onSubmit={otpSent ? handleSignIn : handleSendOtp}>
              {/* Email Input with Icon */}
              <TextField
                type="email"
                label="Enter your email"
                variant="outlined"
                fullWidth
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                sx={{
                  mb: 2,
                  '& .MuiOutlinedInput-root': {
                    borderRadius: '8px',
                    backgroundColor: '#fafafa'
                  },
                  '& .MuiInputAdornment-root': {
                    color: '#1976d2'
                  }
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <EmailIcon />
                    </InputAdornment>
                  )
                }}
                required
                disabled={otpSent}
              />

              {otpSent && (
                <Stack direction="row" spacing={2} justifyContent="center" sx={{ mb: 2 }}>
                  {otp.map((digit, index) => (
                    <TextField
                      key={index}
                      inputRef={(el) => (otpInputs.current[index] = el)}
                      type="text"
                      variant="outlined"
                      value={digit}
                      required
                      onChange={(e) => handleOtpChange(index, e.target.value)}
                      onKeyDown={(e) => handleOtpKeyDown(index, e)}
                      inputProps={{
                        maxLength: 1,
                        style: {
                          textAlign: 'center',
                          fontSize: '18px',
                          fontWeight: 'bold'
                        }
                      }}
                      sx={{ width: '50px', height: '50px' }}
                    />
                  ))}
                </Stack>
              )}

              <Button type="submit" fullWidth variant="contained" color="primary" sx={{ py: 1.5, fontSize: '16px', borderRadius: '8px' }}>
                {otpSent ? 'Sign In' : 'Send OTP'}
              </Button>

              {otpSent && (
                <Typography
                  variant="body2"
                  sx={{
                    mt: 2,
                    color: resendTimer > 0 ? 'gray' : '#1976d2',
                    textAlign: 'center',
                    cursor: resendTimer > 0 ? 'default' : 'pointer'
                  }}
                  onClick={resendTimer === 0 ? handleResendOtp : null}
                >
                  {resendTimer > 0 ? `Resend OTP in ${resendTimer}s` : 'Resend OTP'}
                </Typography>
              )}
            </form>

            {message && (
              <Alert severity="success" sx={{ mt: 2 }}>
                {message}
              </Alert>
            )}
            {error && (
              <Alert severity="error" sx={{ mt: 2 }}>
                {error}
              </Alert>
            )}
          </Paper>
        </Paper>
      </Box>
      </motion.div>

      <Backdrop open={loader}>
        <svg width={0} height={0}>
          <defs>
            <linearGradient id="my_gradient" x1="0%" y1="0%" x2="0%" y2="100%">
              <stop offset="0%" stopColor="#4169E1" />
              <stop offset="30%" stopColor="#f5f5f5" />
              <stop offset="100%" stopColor="#fff" />
            </linearGradient>
          </defs>
        </svg>
        <CircularProgress sx={{ 'svg circle': { stroke: 'url(#my_gradient)' } }} size={70} thickness={3} />
      </Backdrop>
    </>
  );
};

export default PresDectLogin;
